import { isSameYear } from "date-fns";
import { formatDate } from "@/helper/date-time";
import { BarChartPaymentStatisticalViewProps } from "../types/payment-statistical-view.type";
import { useMemo } from "react";
import { extractDateComponents } from "@/helper/chart/build-line-chart";
import { SummaryChartOptionProps } from "@/helper/chart/summary-chart.util";

export const useGetSeriesBarChartPaymentByData = ({
  paymentHistoryStatisticData,
  startDate,
  endDate,
}: BarChartPaymentStatisticalViewProps) => {
  return useMemo(() => {
    const chartData: SummaryChartOptionProps = {
      xAxis: [],
      data: [],
    };
    if (!startDate || !endDate) {
      return chartData;
    }

    // We need to add one day to the end date to ensure that the full year is displayed correctly when the start and end dates are in the same year
    const endDatePlusDay = new Date(endDate);
    endDatePlusDay.setDate(endDatePlusDay.getDate() + 1);

    if (!isSameYear(startDate, endDatePlusDay)) {
      /**
       * If different year, show the full date
       * **/
      for (const item of paymentHistoryStatisticData) {
        chartData.xAxis.push(item.id);
        chartData.data.push(item.amount / 100);
      }
    } else {
      for (const item of paymentHistoryStatisticData) {
        const dateComponents = extractDateComponents(item.id);
        if (!dateComponents) {
          continue;
        }

        let formattedDate = "";
        if (dateComponents.hour) {
          const date = new Date(
            `${dateComponents.year}-${dateComponents.month}-${dateComponents.day}T${dateComponents.hour}:00`,
          );
          formattedDate = formatDate(date, { format: "dd/MM HH:mm" });
        } else if (dateComponents.day) {
          const date = new Date(`${dateComponents.year}-${dateComponents.month}-${dateComponents.day}`);
          formattedDate = formatDate(date, { format: "d MMM" });
        } else if (dateComponents.week) {
          formattedDate = `Semaine: ${dateComponents.week}`;
        }

        chartData.xAxis.push(formattedDate);
        chartData.data.push(item.amount / 100);
      }
    }

    return chartData;
  }, [startDate, endDate, paymentHistoryStatisticData]);
};
